module.exports = __webpack_public_path__ + "static/adaptix-65fe266feeea396b2c7a51bfbdaaaeb1.jpg";